<script setup>
import { mdiCog } from '@mdi/js'
import CardBox from '@/components/CardBox.vue'
import NumberDynamic from '@/components/NumberDynamic.vue'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseLevel from '@/components/BaseLevel.vue'
import PillTagTrend from '@/components/PillTagTrend.vue'
import BaseButton from '@/components/BaseButton.vue'
import { computed, onBeforeMount, ref, reactive, watch } from 'vue'

const mainCurrency = ref('SUM')
onBeforeMount(async () => {
  mainCurrency.value = props.firstCurrency
})
const props = defineProps({
  firstCurrency: {
    type: String,
    default: "firstCurrency"
  },
  secondCurrency: {
    type: String,
    default: "secondCurrency"
  },
  exchangeRate: {
    type: Number,
    default: 100
  },
})
function handleClickExchangeRate() {
  if (mainCurrency.value === props.firstCurrency) {
    mainCurrency.value = props.secondCurrency
  } else {
    mainCurrency.value = props.firstCurrency
  }
}

</script>

<template>
  <CardBox>
    <BaseLevel mobile>
      <div>
        <h3 class="cursor-pointer text-lg leading-tight text-gray-500 dark:text-slate-400" @click="handleClickExchangeRate">
          {{ mainCurrency === firstCurrency? `${firstCurrency} 🔄 ${secondCurrency}`: `${secondCurrency} 🔄 ${firstCurrency}` }}
        </h3>
        <h1 class="text-3xl leading-tight font-semibold">
          <NumberDynamic :value="mainCurrency === firstCurrency? exchangeRate.toFixed(12): (1/exchangeRate).toFixed(12)" />
        </h1>
      </div>
    </BaseLevel>
  </CardBox>
</template>
